import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";

import { ReviewData } from "../../../models/ReviewData";

import "./styles.scss";

interface IReviewItemProps {
  review: ReviewData;
}

export const ReviewItem: React.FunctionComponent<IReviewItemProps> = ({
  review,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.recentReviews.${key}`);

  const formatDate = (date: Date | string) => {
    return dayjs(date).format("YYYY/MM/DD");
  };

  const renderStars = (rating?: number) => {
    if (!rating) return null;

    return (
      <div className="stars">
        {Array.from({ length: 5 }, (_, index) => (
          <span key={index} className={index < rating ? "star filled" : "star"}>
            ⭐️
          </span>
        ))}
      </div>
    );
  };

  const formatComment = (comment?: string) => {
    if (!comment) return "";

    const lines = comment.split("\n");
    if (lines.length > 5) {
      return lines.slice(0, 5).join("\n") + "...";
    }
    return comment;
  };

  return (
    <div className="review-item">
      <div className="review-header">
        <div className="reviewer-info">
          <span className="reviewer-name">
            {review.reviewer_name || t("no_name")}
          </span>
          {renderStars(review.rating)}
        </div>
        <div className="review-date">{formatDate(review.review_date)}</div>
      </div>
      <div className="review-content">{formatComment(review.comment)}</div>
    </div>
  );
};

export default ReviewItem;
